function dealerAgentMaster() {
    let profileService = [
        {
            name: "Agent Master",
            icon: "Agent Master",
            logoName: "fee",
            // flag: "voucherRequired",
            displayService: "dealerAgentMaster",
            items: [],
        },
    ];

    const dashboard = () => {
        const dashboardArr = [
            {
                path: "/index/dealerAgentMaster",
                name: "Dashboard",
                icon: "dashboard",
                logoName: "dashboard",
                flag: "",
            },
        ];

        return dashboardArr;
    };

    const agentMaster = () => {
        const profileArr = [
            {
                path: "/index/agentMaster",
                name: "Agent Master",
                icon: "fee-master",
                logoName: "customer master",
            },
        ];
        return profileArr;
    };

    let a = dashboard();
    let b = agentMaster();
    profileService[0].items = [...a, ...b];

    return profileService;
}
export default dealerAgentMaster;